/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const requestLoginLinkInputDataSchema = z.object({
	email: z.string().email(),
})

export type RequestLoginLinkInputDataSchema = z.infer<typeof requestLoginLinkInputDataSchema>
